import { useEffect, useState } from "react";
import axiosInstance from "../api/axiosInstance";
import { toast } from "react-toastify";

export default function TodaysPatientAppointments({ patientPhone }: any) {
  const [appointments, setAppointments] = useState([]);

  const loadData = () => {
    axiosInstance
      .post("/appointment/doctor/today-patient", { patientPhone })
      .then((res) => setAppointments(res.data))
      .catch(() => toast.error("Failed to load today's appointments"));
  };

  useEffect(() => {
    if (patientPhone) loadData();
  }, [patientPhone]);

  const markViewed = async (appointmentId: number, checked: boolean) => {
    try {
      await axiosInstance.post("/appointment/mark-viewed", {
        appointmentId,
      });

      toast.success("Marked as viewed");
      loadData();
    } catch (err) {
      toast.error("Failed to update status");
    }
  };

  if (appointments.length === 0) return null;

  return (
    <div className="mb-8 bg-white p-5 rounded-xl shadow">
      <h2 className="text-2xl font-bold mb-4 text-indigo-700">
        Today's Appointments for Patient
      </h2>

      <div className="overflow-x-auto rounded-lg border">
        <table className="w-full">
          <thead className="bg-indigo-600 text-white">
            <tr>
              <th className="p-3 text-left">Profile</th>
              <th className="p-3 text-left">Name</th>
              <th className="p-3 text-left">Phone</th>
              <th className="p-3 text-left">Email</th>
              <th className="p-3 text-left">Viewed</th>
            </tr>
          </thead>

          <tbody>
            {appointments.map((appt: any) => (
              <tr key={appt.appointmentId} className="border-b">
                <td className="p-3">
                  <img
                    src={appt.patient.profile}
                    className="w-12 h-12 rounded-full object-cover"
                  />
                </td>

                <td className="p-3">{appt.patient.name}</td>
                <td className="p-3">{appt.patient.phone}</td>
                <td className="p-3">{appt.patient.email}</td>

                <td className="p-3">
                  <input
                    type="checkbox"
                    checked={appt.status === "VIEWED"}
                    onChange={(e) =>
                      markViewed(appt.appointmentId, e.target.checked)
                    }
                    className="w-5 h-5"
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
